import "../assets/js/canvasjs.min.js";
// import "canvasjs/dist/jquery.canvasjs.min.js"

// import CanvasJS from 'canvasjs';
// var CanvasJS = require('canvasjs');
// import "../../node_modules/canvasjs/dist/canvasjs"
let chartBar = {};
chartBar.chartJS = (config) => {
    CanvasJS.addColorSet("greenShades", [ //colorSet Array
        "#008080",
    ]);

    var chart = new CanvasJS.Chart("chartContainer", {
        colorSet: "greenShades",
        animationEnabled: true,
        theme: "light1",
        exportEnabled: true,
        dataPointMaxWidth: 40,
        title: {
            text: config.title,
            fontSize: 24,
            fontFamily: "tahoma",
            fontColor: "#000000"
        },
        axisX: {
            title: config.titleX,
            fontFamily: "tahoma",
            titleFontSize: 20,
            color: "#000000"
        },
        axisY: {
            title: config.titleY,
            tickColor: "red",
            tickLength: 5,
            tickThickness: 2,
            titleFontSize: 20,
            fontFamily: "tahoma",
            color: "#000000"
        },
        toolTip: {
            shared: true,
            content: ` {y} lượt - Ngày {label}`
        },
        legend: {
            cursor: "pointer",

        },
        data: [{
            type: "column", //change type to bar, line, area, pie, etc
            //indexLabel: "{y}", //Shows y value on all Data Points
            indexLabelFontColor: "#5A5757",
            indexLabelPlacement: "outside",
            dataPoints: config.dataPoint
        }]
    });
    chart.render();
};
export default chartBar;